module.exports = __webpack_public_path__ + "static/media/ana.9990e83b.png";